document.addEventListener('DOMContentLoaded', function () {
  
  const mainDataEl = document.getElementById('main-product-data');
  if (!mainDataEl) return;

  // 💡 최대 할인 적용 개수 (쇼피파이 설정과 동일하게 맞춤)
  const MAX_DISCOUNT_PAIRS = 2;

  let mainData = { price: 0, variants: [] };
  let i18n = { addon: '', colorLabel: '', totalPrefix: '', totalSuffix: '', discount: '', discountApplied: '', regularPrice: '', ea: '' };
  let mainPrice = 0;

  try {
    mainData = JSON.parse(mainDataEl.textContent);
    i18n = mainData.i18n || i18n;
    mainPrice = mainData.price || 0;
  } catch (e) {
    console.error('JSON 파싱 에러:', e);
  }

  const selectedCrossSells = new Map();
  const crossSellListContainer = document.getElementById('cross-sell-summary-list');
  const totalCountText = document.getElementById('total-count-text');
  const totalPriceText = document.getElementById('total-price-text');

  function getMainQuantity() {
    const nativeQtyInput = document.querySelector('input[name="quantity"]') || document.querySelector('.quantity__input');
    if (nativeQtyInput) {
      const val = parseInt(nativeQtyInput.value);
      return isNaN(val) || val < 1 ? 1 : val;
    }
    return 1;
  }

  function formatMoney(amount) {
    if (!mainData.priceFormatted) return amount;
    const formatted = new Intl.NumberFormat().format(Math.round(amount / 100));
    return mainData.priceFormatted.replace(/[\d,.]+/, formatted);
  }

  function updateMainVariantPrice() {
    const variantIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"], .product-form input[name="id"]');
    if (variantIdInput && variantIdInput.value && mainData.variants) {
      const selectedVariant = mainData.variants.find(v => String(v.id) === String(variantIdInput.value));
      if (selectedVariant) {
        mainPrice = selectedVariant.price;
        renderCrossSellSummaries();
        return;
      }
    }

    const selectedOptions = [];
    document.querySelectorAll('variant-radios input:checked, variant-selects select, .product-form input[type="radio"]:checked').forEach(input => {
      if(input.value) selectedOptions.push(input.value);
    });

    if (selectedOptions.length > 0 && mainData.variants) {
      const found = mainData.variants.find(v => v.options.every(opt => selectedOptions.includes(opt)));
      if (found) {
        mainPrice = found.price;
        renderCrossSellSummaries();
      }
    }
  }

  // --- 이벤트 감지 ---
  document.addEventListener('click', function(event) {
    const header = event.target.closest('.cross-sell-header');
    if (header) {
      const card = header.closest('.cross-sell-card');
      const body = card.querySelector('.cross-sell-body');
      const arrow = card.querySelector('.cross-sell-arrow');
      if (body) {
        const isHidden = body.style.display === 'none' || window.getComputedStyle(body).display === 'none';
        body.style.display = isHidden ? 'block' : 'none';
        if (arrow) arrow.textContent = isHidden ? '▲' : '▼';
      }
      return;
    }

    const removeBtn = event.target.closest('.remove-cross-btn');
    if (removeBtn) {
      selectedCrossSells.delete(removeBtn.dataset.id);
      renderCrossSellSummaries();
      return;
    }

    const qtyBtn = event.target.closest('.cs-qty-btn');
    if (qtyBtn) {
      const variantId = qtyBtn.dataset.id;
      if (selectedCrossSells.has(variantId)) {
        const item = selectedCrossSells.get(variantId);
        if (qtyBtn.dataset.action === 'plus') item.qty++;
        else if (qtyBtn.dataset.action === 'minus' && item.qty > 1) item.qty--;
        renderCrossSellSummaries();
      }
      return;
    }

    // 메인 상품 수량 버튼을 누를 때마다 요약 카드(할인 조건) 재계산
    if (event.target.closest('.quantity__button, [name="minus"], [name="plus"]')) {
      setTimeout(renderCrossSellSummaries, 50);
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.matches('.cross-sell-variant-select')) {
      const select = event.target;
      const opt = select.options[select.selectedIndex];
      if (!select.value || opt.disabled) return;

      const variantId = select.value;
      if (selectedCrossSells.has(variantId)) {
        selectedCrossSells.get(variantId).qty += 1;
      } else {
        selectedCrossSells.set(variantId, {
          id: variantId, 
          productTitle: select.dataset.productTitle || '', 
          optionTitle: opt.dataset.title || '', 
          price: parseInt(opt.dataset.price) || 0, 
          originalPrice: parseInt(opt.dataset.originalPrice) || 0, 
          qty: 1
        });
      }
      select.value = ""; 
      renderCrossSellSummaries();
      return;
    }

    if (event.target.closest('variant-radios, variant-selects, .product-form, input[name^="options"], select[name^="options"]')) {
      setTimeout(updateMainVariantPrice, 100);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('input[name="quantity"], .quantity__input')) {
      renderCrossSellSummaries();
    }
  });


  // --- 🌟 핵심: 수량에 따른 할인 배분 및 렌더링 ---
  function renderCrossSellSummaries() {
    if (!crossSellListContainer) return;
    crossSellListContainer.innerHTML = '';

    const mainQty = getMainQuantity();
    // 메인 상품 개수만큼 할인을 주되, 최대 2개까지만 허용 (Math.min 사용)
    let remainingDiscounts = Math.min(mainQty, MAX_DISCOUNT_PAIRS); 
    
    let overallTotalQty = mainQty;
    let overallTotalPrice = mainPrice * mainQty;

    selectedCrossSells.forEach((item, variantId) => {
      let discountQty = 0;
      let regularQty = 0;

      // 추가 상품들에 순차적으로 남은 할인을 분배
      if (remainingDiscounts > 0) {
        if (item.qty <= remainingDiscounts) {
          discountQty = item.qty;
          remainingDiscounts -= item.qty;
        } else {
          discountQty = remainingDiscounts;
          regularQty = item.qty - remainingDiscounts;
          remainingDiscounts = 0;
        }
      } else {
        regularQty = item.qty;
      }

      // 분배된 결과에 따라 아이템 총액 계산
      const itemTotalPrice = (discountQty * item.price) + (regularQty * item.originalPrice);
      const itemTotalOriginal = item.qty * item.originalPrice;

      overallTotalQty += item.qty;
      overallTotalPrice += itemTotalPrice;

      // 요약 카드 HTML 생성 (할인 분배 상태에 따라 UI가 다름)
      let priceHtml = '';
      if (discountQty > 0) {
        if (regularQty > 0) {
          // 1. 일부만 할인되고, 나머지는 정가인 경우 (예: 마우스패드 3개 중 1개만 할인)
          priceHtml = `
            <div style="font-size: 11px; color: #999; text-decoration: line-through; margin-bottom: 2px;">${formatMoney(itemTotalOriginal)}</div>
            <div style="font-size: 14px; font-weight: 700; color: #111;">
              <span style="color: #e53935; font-size: 13px; margin-right: 4px;">${i18n.discount}</span>${formatMoney(itemTotalPrice)}
            </div>
            <div style="font-size: 11px; color: #666; margin-top: 4px; letter-spacing: -0.5px;">(${i18n.discountApplied}${discountQty}${i18n.ea} / ${i18n.regularPrice}${regularQty}${i18n.ea})</div>
          `;
        } else {
          // 2. 고른 개수 전부 할인이 들어간 경우
          priceHtml = `
            <div style="font-size: 11px; color: #999; text-decoration: line-through; margin-bottom: 2px;">${formatMoney(itemTotalOriginal)}</div>
            <div style="font-size: 14px; font-weight: 700; color: #111;">
              <span style="color: #e53935; font-size: 13px; margin-right: 4px;">${i18n.discount}</span>${formatMoney(itemTotalPrice)}
            </div>
          `;
        }
      } else {
        // 3. 할인을 하나도 못 받고 전부 정가인 경우
        priceHtml = `
          <div style="font-size: 14px; font-weight: 700; color: #111;">${formatMoney(itemTotalPrice)}</div>
        `;
      }

      const card = document.createElement('div');
      card.style.cssText = 'background: #f7f7f7; padding: 12px 14px; border-radius: 6px; margin-bottom: 10px; position: relative;';
      card.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 4px; padding-right: 20px;">
          <div style="font-size: 13px; color: #333; font-weight: 600;">${i18n.addon}</div>
          <button type="button" class="remove-cross-btn" data-id="${variantId}" style="position: absolute; right: 8px; top: 8px; background: none; border: none; font-size: 15px; color: #888; cursor: pointer; padding: 4px;">✕</button>
        </div>
        <div style="font-size: 13px; color: #555; margin-bottom: 8px;">
          ${item.productTitle} ${i18n.colorLabel} ${item.optionTitle}
        </div>
        <div style="display: flex; justify-content: space-between; align-items: flex-end;">
          <div style="display: flex; border: 1px solid #ddd; background: #fff; border-radius: 3px;">
            <button type="button" class="cs-qty-btn" data-id="${variantId}" data-action="minus" style="width: 26px; height: 26px; border: none; background: none; cursor: pointer;">-</button>
            <input type="text" value="${item.qty}" readonly style="width: 30px; height: 26px; border: none; text-align: center; font-size: 12px;">
            <button type="button" class="cs-qty-btn" data-id="${variantId}" data-action="plus" style="width: 26px; height: 26px; border: none; background: none; cursor: pointer;">+</button>
          </div>
          <div style="text-align: right;">
            ${priceHtml}
          </div>
        </div>
      `;
      crossSellListContainer.appendChild(card);
    });

    // 최종 총금액 반영
    if (totalCountText && totalPriceText) {
      totalCountText.textContent = `${i18n.totalPrefix}${overallTotalQty}${i18n.totalSuffix}`;
      totalPriceText.textContent = formatMoney(overallTotalPrice);
    }
  }

  // --- 장바구니 전송 ---
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async function (event) {
      if (event.source !== 'product-form') return;
      const items = [];
      selectedCrossSells.forEach(item => items.push({ id: item.id, quantity: item.qty }));
      if (items.length === 0) return;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
    });
  }

  updateMainVariantPrice();
});